const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: currentYear - 2010 + 1 }, (_, i) => ({
    label: (2010 + i).toString(),
    value: (2010 + i).toString(),
}));